<template>
	<Empty v-if="certificates.length === 0"/>
	<CardGrid v-else>
		<Card
			v-for="certificate in certificates"
			:key="`certificates-${certificate.id}`"
			:title="certificate.title && certificate.title.trim().length > 0 ? certificate.title : trans('general.n_a')"
			:subtitle="certificate.size"
		>
			<template #footer>
				<Link :as="SecondaryButton" :color="Color.Blue" :href="route('certificates.edit', {certificate: certificate.id, returnUrl: returnUrl, returnLabel: returnLabel})">
					<i class="fa-solid fa-edit mr-2"/>
					{{ trans('general.edit') }}
				</Link>
				<SoftButton :color="Color.Red" @click.stop="remove(certificate)">
					<i class="fa-solid fa-trash mr-2"/>
					{{ trans('general.delete') }}
				</SoftButton>
			</template>
		</Card>
	</CardGrid>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {type Ref, ref} from 'vue'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import Card from '@/Components/UI/Cards/Card.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import SoftButton from '@/Components/UI/Buttons/SoftButton.vue'
import {type Certificate} from '@/Types/Certificates/Certificate'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'

const props = defineProps<{
	returnUrl:string,
	returnLabel:string,
	certificates:Array<Certificate>,
}>()

const working:Ref<boolean> = ref(false)
const certificates:Ref<Array<Certificate>> = ref(props.certificates)

function remove(certificate:Certificate):void{
	if(!working.value && confirm(trans('general.confirm_action'))){
		working.value = true
		showInfo(trans('general.deleting'))
		axios.delete(route('certificates.delete', certificate.id)).then(() => {
			showSuccess(trans('general.deleted'))
			const index = certificates.value.findIndex((c:Certificate) => c.id === certificate.id)
			if(index > -1){
				certificates.value.splice(index, 1)
			}
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>
